<template>
  <section class="container">
    <van-pull-refresh style="height:100%;" v-model="refresh_loading" @refresh="handleRefresh">
      <div class="modal_header">
        <div class="modal_header__title">停车缴费</div>
        <div class="modal_header__info">¥{{ payMoney.toFixed(2) }}</div>
        <div class="modal_header__countdown">
          支付倒计时:
          <van-count-down @finish="handleRefresh" :time="payment_Countdown" style="color:#FF3366;" ref="countDown" />
        </div>
      </div>
      <div class="order_info">
        <van-cell title="车牌号码" :value="orders.cardNumber" />
        <van-cell title="停车位置" :value="
            orders.parkDesc ? orders.parkDesc.split('-')[0] : orders.parkDesc
          " />
        <van-cell title="入场时间" :value="orders.entranceDate" />
        <van-cell title="停车时长" :value="orders.parkingTime" />
        <van-cell title="应缴金额" :value="'¥' + orders.chargeMoney" />
        <!-- 优惠券单元格 -->
        <van-coupon-cell :coupons="coupons" :chosen-coupon="chosenCoupon" @click="showList = true" />
        <!-- 优惠券列表 -->
        <van-popup v-model="showList" position="bottom">
          <van-coupon-list :coupons="coupons" :chosen-coupon="chosenCoupon" :disabled-coupons="disabledCoupons"
            @change="onChange" @exchange="onExchange" />
        </van-popup>
        <van-cell title="实缴费用" :value="'¥' + payMoney.toFixed(2)" />
        <van-cell :value="fristPayWay.name" @click="pay_way_show = true" is-link>
          <template slot="title">
            <span class="custom-title">支付方式</span>
            <van-tag v-if="fristPayWay.frist" style="margin-left:5px;" type="danger">
              推荐
            </van-tag>
          </template>
        </van-cell>
      </div>
    </van-pull-refresh>
    <div class="btn_box bottom">
      <van-button :disabled="!payMoney>0" @click="submit" size="large" class="blue-btn">
        缴费离场
      </van-button>
    </div>
    <!-- 支付方式选择 -->
    <van-action-sheet v-model="pay_way_show" :actions="payWay" @select="payWayChange" close-on-click-action
      safe-area-inset-bottom cancel-text="取消" description="请选择下列支付方式" @cancel="onCancel" />
  </section>
</template>

<script>
import { Popup, CouponCell, CouponList, PullRefresh, CountDown, Tag, ActionSheet, Dialog } from 'vant'
import { CCB_UnderOrder, CCB_Payment, SNPayEncrypt } from '@/api/transaction'
import { weixinPay, unifiedOrder } from '@/api/wechat'
import { getStopCarInfo } from '@/api/park'
import { parseTime, getTimeval, deepClone, isSnYiFuBao, sortASCII, EncryptReplace } from '@/utils'
import md5 from 'js-md5'
import QS from 'qs'
import { setLocalStorage, getLocalStorage } from '@/utils/auth'
import { Base64 } from 'js-base64'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  props: {
    orders: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    [Popup.name]: Popup,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [PullRefresh.name]: PullRefresh,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    [ActionSheet.name]: ActionSheet,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    payMoney () {
      let price = 0;
      if (!this.orders.chargeMoney && !this.orders.paidMoney) {
        return price
      }

      if (this.orders.discountType > 0) {
        price = this.orders.paidMoney;
      } else {
        price = this.orders.chargeMoney;
      }

      let m = 0;
      if (this.chosenCoupon >= 0) {
        m = price - this.coupons[this.chosenCoupon].value / 100;
        return m < 0 ? 0 : m;
      } else {
        return price;
      }
    },
    //优先支付方式
    fristPayWay () {
      // 如果选择了支付渠道
      let initPayWay =
        this.payWayChannel != null ? this.payWayChannel.payChannel : null
      let payWay = null
      if (initPayWay) {
        payWay = initPayWay
      } else if (
        getLocalStorage('defaultPayway') &&
        this.payWay.includes(getLocalStorage('defaultPayway')) //默认支付方式中同样存在该支付值
      ) {
        payWay = getLocalStorage('defaultPayway')
      } else {
        payWay = this.payWay[0].payChannel
      }
      return this.$enumObject.getPayWay(payWay)
    },
    ...mapGetters(['wx_userInfo'])
  },
  data () {
    return {
      payWay: [], //支付渠道
      payWayChannel: null, //默认建行聚合支付
      pay_way_show: false,
      refresh_loading: false,
      payment_Countdown: 5 * 60 * 1000,
      under_Order_Loading: null,
      CCB_Aggregate_pay: {
        //建行聚合支付接口参数
        MERCHANTID: '', //商户代码
        POSID: '', //商户柜台代码
        BRANCHID: '', //分行代码
        ORDERID: parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') +
          Math.round(Math.random() * 100), //订单号
        PAYMENT: '', //付款金额
        CURCODE: '', //币种
        TXCODE: '',
        REMARK1: '2', //场内码支付
        REMARK2: '', //MAC地址
        RETURNTYPE: '3',
        TIMEOUT: '',
        PUB: ''
      },
      Suning_Aggregate_pay: {
        merchantNo: '', //系统接入方
        merchantDomain: document.domain, //交易发起方商户域名
        publicKeyIndex: '', //公钥索引
        signature: '', //签名
        signAlgorithm: '', //签名算法
        inputCharset: '', //系统接入方
        notifyUrl: '', //服务器异步通知URL
        returnUrl: '', //页面跳转同步通知页面路径
        version: '', //接口版本号
        submitTime: '', //提交时间
        orders: {
          salerMerchantNo: '', //卖家商户号
          orderType: '', //订单类型
          outOrderNo: '', //parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') +Math.round(Math.random() * 100)//订单号
          merchantOrderNo: '', //订单号
          goodsName: '', //商品名称
          goodsType: '', //商品类型
          orderAmount: 0, //订单金额 分为单位
          currency: '', //币种
          orderTime: '', //下单时间该订单在商户系统的创建时间，同一笔订单的创建时间不能修改，否则会报错，对账时需要(格式yyyyMMddHHmmss)
          remarks: '' //附加数据 JSON格式，采用encodeBase64URLSafeString加密处理 场内码支付
        }
      },
      showList: false,
      chosenCoupon: -1,
      coupons: [
        // {
        //   available: 1,
        //   condition: '无使用门槛\n最多优惠12元',
        //   reason: '',
        //   value: 150,
        //   name: '优惠券名称',
        //   startAt: 1489104000,
        //   endAt: 1514592000,
        //   valueDesc: '1.5',
        //   unitDesc: '元'
        // }
      ],
      disabledCoupons: [
        // {
        //   id: 1, //优惠券id
        //   discount: 0, //折扣券 折值 整数 为0不显示折
        //   denominations: 100, //优惠券金额 单位分
        //   originCondition: 0, //满减规则金额 单位分 为0显示无门槛
        //   value: 0, //折扣券优惠金额，单位分
        //   name: '优惠券名称', //优惠券名称
        //   description: '描述信息', //描述信息
        //   reason: '', //不可用原因，优惠券不可用时展示
        //   startAt: 1489104000, //卡有效开始时间 (时间戳, 单位秒)
        //   endAt: 1514592000 //卡失效日期 (时间戳, 单位秒)
        // }
      ]
    }
  },
  created () {
    this.getPayConfig()
  },
  methods: {
    //获取支付配置
    getPayConfig () {
      let _this = this
      // 获取支持的支付渠道
      let payList = _this.$enumObject.providerConfig[config.projectName].payList
      // 如果为苏宁易付宝客户端 那么只加载苏宁支付
      if (isSnYiFuBao() && payList.indexOf(61) > -1) {
        _this.payWay = [_this.$enumObject.getPayWay(61)] //苏宁支付
        //苏宁支付易付宝回调JS-SDK调用方法
        window.payResult = function (string) {
          if (string == 'success') {
            //支付成功
            _this.$router.push({
              name: 'PayResult',
              query: {
                outOrderNo: _this.Suning_Aggregate_pay.orders.outOrderNo,
                orderTime: _this.Suning_Aggregate_pay.orders.orderTime
              }
            })
          } else if (string == 'fail') {
            //支付失败
            alert('支付失败')
          } else if (string == 'cancel') {
            //支付取消
            alert('支付取消')
          }
        }
      } else {
        // 渲染支持的支付渠道
        _this.payWay = []
        for (let index = 0; index < payList.length; index++) {
          const element = payList[index]
          _this.payWay.push(_this.$enumObject.getPayWay(element))
        }
      }
    },
    handleRefresh () {
      let _this = this
      // 跳转存在订单
      // query内数据存在,使用地址中存在的订单信息查询该订单
      let params = {
        cardNumber: _this.orders.cardNumber,
        parkId: _this.orders.parkId
      }
      getStopCarInfo(params)
        .then(response => {
          let data = response.body
          if (data.entranceDate) {
            let exitDate = data.exitDate || parseTime(new Date())
            data.parkingTime = getTimeval(data.entranceDate, exitDate)
          }
          _this.orders = deepClone(data)
          _this.refresh_loading = false
          _this.$nextTick(() => {
            //异步执行
            _this.$refs.countDown.reset()
          })
        })
        .catch(error => {
          _this.refresh_loading = false
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    onChange (index) {
      this.showList = false
      this.chosenCoupon = index
    },
    onExchange (code) {
      console.log(code)
      // this.coupons.push(code)
    },
    // 点击支付方式
    payWayChange (item) {
      this.payWayChannel = JSON.parse(JSON.stringify(item))
    },
    // 建行聚合支付
    CCB_UnderOrder_Submit () {
      let _this = this
      //使用项目对应支付配置
      _this.CCB_Aggregate_pay = Object.assign(
        _this.CCB_Aggregate_pay,
        _this.$enumObject.providerConfig[config.projectName].payConfigCCB
      )
      _this.under_Order_Loading = _this.$toast.loading('加载中...')
      let params = {
        MERCHANTID: _this.CCB_Aggregate_pay.MERCHANTID,
        POSID: _this.CCB_Aggregate_pay.POSID,
        BRANCHID: _this.CCB_Aggregate_pay.BRANCHID,
        ORDERID: `${_this.CCB_Aggregate_pay.ORDERID}_${_this.orders.id}`,
        PAYMENT: _this.payMoney, //_this.payMoney
        CURCODE: _this.CCB_Aggregate_pay.CURCODE,
        TXCODE: _this.CCB_Aggregate_pay.TXCODE,
        REMARK1: _this.CCB_Aggregate_pay.REMARK1,
        REMARK2: _this.CCB_Aggregate_pay.REMARK2,
        RETURNTYPE: _this.CCB_Aggregate_pay.RETURNTYPE,
        TIMEOUT: _this.CCB_Aggregate_pay.TIMEOUT
      }
      let stitch_url = QS.stringify(params) //拼接的部分url
      params.PUB = _this.CCB_Aggregate_pay.PUB
      let MAC = md5(QS.stringify(params)) //将加进PUB的参数加密
      params.MAC = MAC
      let final_params = `${stitch_url}&MAC=${MAC}`
      CCB_UnderOrder(final_params)
        .then(response => {
          _this.under_Order_Loading.clear()
          if (response.SUCCESS == 'true') {
            // unescape
            CCB_Payment(response.PAYURL.split('/CCBIS')[1])
              .then(res => {
                setLocalStorage('defaultPayway', _this.fristPayWay.payChannel) //记录用户支付方式 作为下次支付默认支付方式
                window.location.href = window.unescape(res.QRURL)
              })
              .catch(err => {
                _this.$notify({
                  type: 'danger',
                  message: err
                })
              })
          } else {
            _this.under_Order_Loading.clear()
            _this.$notify({
              type: 'danger',
              message: response.SUCCESS
            })
          }
        })
        .catch(error => {
          _this.under_Order_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    // 苏宁易付宝支付
    Suning_UnderOrder_Submit () {
      let _this = this
      // 生成查询订单参数
      _this.Suning_Aggregate_pay = Object.assign(
        _this.Suning_Aggregate_pay,
        _this.$enumObject.providerConfig[config.projectName].payConfigSNYiFuBao
      )
      _this.Suning_Aggregate_pay.orders.outOrderNo =
        parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') +
        Math.round(Math.random() * 100000)
      _this.Suning_Aggregate_pay.orders.orderTime = parseTime(
        new Date(),
        '{y}{m}{d}{h}{i}{s}'
      )
      // 生成交易订单参数
      let params = {
        merchantNo: _this.Suning_Aggregate_pay.merchantNo, //系统接入方
        merchantDomain: _this.Suning_Aggregate_pay.merchantDomain, //交易发起方商户域名
        publicKeyIndex: _this.Suning_Aggregate_pay.publicKeyIndex, //公钥索引
        inputCharset: _this.Suning_Aggregate_pay.inputCharset, //编码类型
        notifyUrl: _this.Suning_Aggregate_pay.notifyUrl, //服务器异步通知URL
        returnUrl: _this.Suning_Aggregate_pay.returnUrl, //页面跳转同步通知页面路径
        version: _this.Suning_Aggregate_pay.version, //版本号
        submitTime: parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
      }
      params.orders = JSON.stringify([{
        salerMerchantNo: _this.Suning_Aggregate_pay.orders.salerMerchantNo, //商户号
        orderType: _this.Suning_Aggregate_pay.orders.orderType, //订单类型
        outOrderNo: _this.Suning_Aggregate_pay.orders.outOrderNo, //订单号
        merchantOrderNo: _this.orders.id.toString(), //停车记录id
        goodsName: Base64.encodeURI(`${_this.orders.cardNumber}-停车缴费`), //商品名称
        goodsType: _this.Suning_Aggregate_pay.orders.goodsType, //商品类型
        orderAmount: _this.payMoney * 100, //金额 _this.payMoney * 100
        currency: _this.Suning_Aggregate_pay.orders.currency, //币种
        orderTime: _this.Suning_Aggregate_pay.orders.orderTime, //下单时间
        remarks: '2' //场内码支付
      }])
      params = sortASCII(params) //参数排序 按照字段名的 ASCII 码从小到大排序（字典序，从a到z，首字母相同则看第二个字母））
      let stitch_str = QS.stringify(params, {
        encode: false
      }) //拼接的string
      let MD5Str = md5(stitch_str).toUpperCase()
      SNPayEncrypt({
        sign_src: MD5Str
      })
        .then(response => {
          setLocalStorage('defaultPayway', _this.fristPayWay.payChannel) //记录用户支付方式 作为下次支付默认支付方式
          params.signature = EncryptReplace(response.body)
          params.signAlgorithm = _this.Suning_Aggregate_pay.signAlgorithm //RSA
          let orderInfo = QS.stringify(params, {
            encode: false
          }) //最终拼接的string
          // Dialog({ message: orderInfo }).then(() => {
          let jsonObj = {
            appId: '120001',
            orderInfo: orderInfo
          }
          // 判断是何种支付方式 wap or JS-SDK
          if (isSnYiFuBao() && window.YifubaoJSBridge) {
            // 调用苏宁易付宝支付2.0 JS-SDK收银台
            window.YifubaoJSBridge.openSDK2_0(jsonObj)
          } else {
            // 调用苏宁wap支付
            _this.$toast('暂未开通 敬请期待')
          }
          // })
        })
        .catch(error => {
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    // 微信支付
    Weixin_UnderOrder_Submit () {
      let _this = this
      let params = {
        chargeId: _this.orders.id.toString(), //停车记录id
        cardNumber: _this.orders.cardNumber, //车牌号
        parking: _this.orders.parkDesc, //停车场名称
        paidMoney: _this.payMoney * 100, //付款金额 _this.payMoney * 100
        paidTime: parseTime(new Date()), //付款时间
        outTradeNo: `wx${parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + Math.round(Math.random() * 100)}_${_this.orders.id}_2`, //商户系统内部订单号，要求32个字符内，只能是数字、大小写字母_-|* 且在同一个商户号下唯一
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : '', //trade_type=JSAPI时（即JSAPI支付），此参数必传，此参数为微信用户在商户对应appid下的唯一标识。
        mac: _this.orders.posId, //硬件地址
        parkId: _this.orders.parkId, //停车场Id
        handleAmount: (_this.orders.chargeMoney * 100).toString(), //应收金额
        discountAmount: (_this.orders.discount * 100).toString(), //折扣金额
        totalFee: _this.payMoney * 100, //实付金额 _this.payMoney * 100
        tradeType: 'JSAPI', //JSAPI -JSAPI支付 NATIVE -Native支付 APP -APP支付
        body: `${_this.orders.cardNumber}·缴纳停车费`, //商品简单描述
        notifyUrl: `${config.authBaseURL}/weChat/notifyUrl/weixin`, //异步接收微信支付结果通知的回调地址，通知url必须为外网可访问的url，不能携带参数
        spbillCreateIp: '127.0.0.1' //	支持IPV4和IPV6两种格式的IP地址。用户的客户端IP this.getUserIP(ip => ip)
      }
      unifiedOrder(params)
        .then(response => {
          let data = response.body
          setLocalStorage('defaultPayway', _this.fristPayWay.payChannel) //记录用户支付方式 作为下次支付默认支付方式
          let params = {
            appId: data.appId,
            timeStamp: data.timeStamp,
            nonceStr: data.nonceStr,
            package: data.packages,
            signType: data.signType,
            paySign: data.paySign
          }
          let callBack = res => {
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              _this.$router.push({
                path: '/pay-result',
                query: {
                  openid: params.openid,
                  chargeId: params.chargeId,
                  outTradeNo: params.outTradeNo,
                  paidTime: params.paidTime
                }
              })
            } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
              _this.$router.push('/pay-result')
            } else {
              //预留，目前当作错误处理
              _this.$router.push('/pay-result')
            }
          }
          weixinPay(params, callBack)
        })
        .catch(error => {
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    submit () {
      // 根据支付类型提交支付请求
      this[this.fristPayWay.method]()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100% + 50px + 5vh); //基础高度 + 按键高度 + margin

  .modal_header {
    color: #444444;

    &__title {
      font-size: 18px;
      text-align: center;
      line-height: 24px;
      padding-top: 20px;
    }

    &__info {
      font-size: 42px;
      text-align: center;
      line-height: 80px;
      font-weight: bold;
      font-family: SourceHanSansCN-Bold;
    }

    &__countdown {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }
  }

  .bottom {
    margin: 20px auto 20px;
  }

  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
}
</style>